import { FC } from 'react'
import { AppraisalSeasonDto } from '../../../types'
import PerText from '../Text'
import PerButtonCircle from '../ButtonCircle'
import { useTranslation } from 'react-i18next'

interface ASSelectProps {
  appraisalSeason: AppraisalSeasonDto
  showIcon: boolean
}

export const AppraisalSeasonRow: FC<ASSelectProps> = ({ appraisalSeason, showIcon }) => {
  const [t] = useTranslation()
  return (
    <>
      <PerText display="inline" mr="xxs">
        {appraisalSeason.year}
      </PerText>
      {showIcon && (
        <PerButtonCircle
          icon="info_fill"
          size="small"
          color="secondary"
          variant="pastel"
          className="disable-shadow"
          tooltip={
            <>
              <PerText>{t('meetingInvite.appraisalSeasonDisclaimer', { appraisalSeasonYear: appraisalSeason.year })}</PerText>
            </>
          }
        />
      )}
    </>
  )
}
